import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { defaultWorkItemsData, useWorkItemsLazyQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectWorkItemFile: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const [
    { data: { data: workItems } = defaultWorkItemsData, isInitialLoading: isLoadingWorkItems },
    getWorkItems,
  ] = useWorkItemsLazyQuery();

  useEffect(() => {
    if (!pathParameters.process_id || !pathParameters.work_item_id) return;
    getWorkItems({ scope: 'process', processId: pathParameters.process_id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathParameters.process_id, pathParameters.work_item_id]);

  const fileIds = useMemo(() => {
    return (
      workItems
        ?.find((item) => item.id === pathParameters.work_item_id)
        ?.files?.map((file) => {
          return { label: file.name, value: file.id };
        }) || []
    );
  }, [pathParameters.work_item_id, workItems]);

  return (
    <ApiHelperSelectInput
      label={t('chooseWorkItemFile')}
      items={fileIds}
      onChange={(value) => setValue('file_id', value)}
      loading={isLoadingWorkItems}
      value={value}
      noItemsFound={t('noWorkItemFiles')}
      {...props}
    />
  );
};
